import React from "react";
import Training from "../../Images/Training.svg";
import Institution from "../../Images/Institution.svg";
import Independent from "../../Images/Independent.svg";
import Logo from "../../Images/SkillsMD logo.svg";
import { useNavigate } from "react-router-dom";
import Footer from "../LandingPage/Components/Footer"
const pathways = [
  {
    title: "Institutional Partner",
    description: "Hospital or university partnering for large-scale programs.",
    examples:
      "Teaching hospitals, medical schools, residency programs, health systems",
    button: "Select Institutional Partner",
    logo: Institution,
    path: "/register_institution", 
  },
  {
    title: "Training Provider",
    description:
      "Organization delivering structured medical programs with faculty.",
    examples:
      "Medical simulation centers, clinical training academies, CPR / ACLS certification bodies",
    button: "Select Training Provider",
    logo: Training,
    path: "/register_trainingprovider", 
  },
  {
    title: "Independent Trainer",
    description:
      "Licensed healthcare professional offering training independently.",
    examples:
      "Freelance surgeons, specialist physicians, nurse educators, paramedic instructors",
    button: "Select Independent Trainer",
    logo: Independent,
    path: "/register_independenttrainer", 
  },
];

const Registration = () => {
  const navigate = useNavigate();
  
  return (
    <div className="min-h-screen flex flex-col bg-gray-50">
      {/* HEADER */}
      <header className="bg-[#4AACC5] text-white">
        <div className="max-w-7xl mx-auto px-6 py-4 flex justify-between items-center">
          <h1 className="text-xl font-bold">
            <img src={Logo} alt="Logo" />
          </h1>
          <button
            className="text-sm font-semibold hover:underline"
            onClick={() => navigate("/login")}
          >
            Login
          </button>
        </div>

        <div className="text-center py-12 px-4">
          <h2 className="text-4xl font-bold mb-4">Registration</h2>
          <p className="text-white/80 max-w-2xl mx-auto">
            Select your pathway to get started. Each route has a tailored
            registration process.
          </p>
        </div>
      </header>

      {/* CONTENT */}
      <main className="flex-grow max-w-7xl mx-auto px-6 py-12">
        <h3 className="text-2xl font-bold text-center mb-12">
          Which pathway describes you best?
        </h3>

        <div className="grid md:grid-cols-3 gap-8">
          {pathways.map((item, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl shadow-sm border border-gray-200 p-6 flex flex-col hover:shadow-md transition"
            >
              <div className="w-16 h-16 bg-blue-50 rounded-2xl flex items-center justify-center mb-4">
                <img src={item.logo} alt="" />
              </div>

              <h4 className="text-xl font-bold text-gray-800 mb-2 text-left">
                {item.title}
              </h4>

              <p className="text-sm text-gray-600 mb-4 text-left">
                {item.description}
              </p>

              <div className="border-t border-gray-100 my-4"></div>

              <p className="text-xs font-semibold text-[#4AACC5] mb-2 text-left">
                EXAMPLES
              </p>

              <p className="text-sm text-gray-400 mb-6 text-left italic">
                {item.examples}
              </p>

             
              <button
                onClick={() => navigate(item.path)}
                className="mt-auto bg-[#4AACC5] text-white text-sm font-semibold py-3 rounded-lg hover:bg-teal-600 transition"
              >
                {item.button} →
              </button>
            </div>
          ))}
        </div>
      </main>

      {/* FOOTER */}
      {/* <footer className="bg-[#4AACC5] text-white text-center py-4">
        © 2026 SkillsMD | All rights reserved
      </footer> */}
      < Footer />
    </div>
  );
};

export default Registration;